import React, { Suspense, lazy, useEffect } from 'react';
import "aos/dist/aos.css";
import './index.css';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from 'react-router-dom';
import {useDocTitle} from './components/CustomHook';
import ScrollToTop from './components/ScrollToTop';

const Home = lazy(() => import('./pages/Home'));
const Contact = lazy(() => import('./pages/Contact'));
const Team = lazy(() => import('./pages/Team'));
const Services = lazy(() => import('./pages/Services'));
const Projects = lazy(() => import('./pages/Projects'));
const HybridRF = lazy(() => import('./pages/HybridRF'));

function App() {
  useEffect(() => {
    let cancelled = false;
    let idleId = null;
    let timeoutId = null;

    const initAos = () => {
      import('aos').then(({ default: AOS }) => {
        if (!cancelled) {
          AOS.init({
            once: true,
            duration: 1000,
            easing: 'ease-out-cubic',
          });
        }
      });
    };

    const scheduleInit = () => {
      if ('requestIdleCallback' in window) {
        idleId = window.requestIdleCallback(initAos);
      } else {
        timeoutId = window.setTimeout(initAos, 0);
      }
    };

    if (document.readyState === 'complete') {
      scheduleInit();
    } else {
      window.addEventListener('load', scheduleInit, { once: true });
    }

    return () => {
      cancelled = true;
      window.removeEventListener('load', scheduleInit);

      if (idleId !== null && 'cancelIdleCallback' in window) {
        window.cancelIdleCallback(idleId);
      }

      if (timeoutId !== null) {
        window.clearTimeout(timeoutId);
      }
    };
  }, []);

  useDocTitle("Chimera Solutions - IT Solutions, fitting to your needs");

  return (
    <div className="overflow-x-hidden">
      <Router>
        <ScrollToTop>
          <Suspense fallback={null}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/services" element={<Services />} />
              <Route path="/team" element={<Team />} />
              <Route path="/projects/*" element={<Projects />} />
              <Route path="/hybridrf" element={<HybridRF />} />
            </Routes>
          </Suspense>
        </ScrollToTop>
      </Router>
    </div>
  );
}

export default App;
